import RelationFineGroup from './relation_fine_group.vue';
import BudgetSubjectTable from './budget_subject_table.vue';
import MaterialForm from './material_table.vue';
import MaterialList from './material_list.vue';

export {
  BudgetSubjectTable,
  MaterialForm,
  MaterialList,
};

export default RelationFineGroup;
